import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

const S = {
  page: { minHeight: '100vh', background: '#f8fafc', fontFamily: "'Inter', system-ui, sans-serif" },
  header: { background: '#fff', borderBottom: '1px solid #e2e8f0', padding: '0 24px' },
  headerInner: { maxWidth: 900, margin: '0 auto', display: 'flex', alignItems: 'center', justifyContent: 'space-between', height: 64 },
  content: { maxWidth: 900, margin: '0 auto', padding: '48px 24px 80px' },
  card: { background: '#fff', borderRadius: 20, border: '1px solid #e2e8f0', padding: '48px 48px', boxShadow: '0 2px 12px rgba(0,0,0,0.04)' },
  h1: { fontSize: 30, fontWeight: 800, color: '#0f172a', margin: '0 0 8px', letterSpacing: '-0.5px' },
  date: { fontSize: 13, color: '#64748b', margin: '0 0 40px', display: 'block', borderBottom: '1px solid #f1f5f9', paddingBottom: 28 },
  h2: { fontSize: 18, fontWeight: 700, color: '#1e293b', margin: '32px 0 12px' },
  p: { fontSize: 15, lineHeight: 1.8, color: '#334155', margin: '0 0 14px' },
  ul: { paddingLeft: 20, margin: '0 0 14px' },
  li: { fontSize: 15, lineHeight: 1.8, color: '#334155', marginBottom: 6 },
};

export default function Kvkk() {
  return (
    <div style={S.page}>
      <header style={S.header}>
        <div style={S.headerInner}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center', gap: 8, color: '#475569', textDecoration: 'none', fontSize: 14, fontWeight: 500 }}>
            <ArrowLeft size={16} /> Ana Sayfa
          </Link>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <img src="/logo.png" alt="temiz-iz.com" style={{ width: 30, height: 30, borderRadius: 8, objectFit: 'contain' }} onError={e => e.target.style.display = 'none'} />
            <span style={{ fontWeight: 800, color: '#1d4ed8', fontSize: 15 }}>temiz-iz.com</span>
          </div>
        </div>
      </header>

      <div style={S.content}>
        <div style={S.card}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 14, marginBottom: 24 }}>
            <div style={{ width: 48, height: 48, borderRadius: 14, background: 'linear-gradient(135deg,#eff6ff,#dbeafe)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Shield size={24} color="#1d4ed8" />
            </div>
            <h1 style={S.h1}>KVKK Aydınlatma Metni</h1>
          </div>
          <span style={S.date}>Son güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}</span>

          <p style={S.p}>
            Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") kapsamında, <strong>temiz-iz.com</strong> tarafından kişisel verilerinizin işlenmesine ilişkin usul ve esasları açıklamak amacıyla hazırlanmıştır.
          </p>

          <h2 style={S.h2}>1. Veri Sorumlusunun Kimliği</h2>
          <p style={S.p}>
            KVKK uyarınca veri sorumlusu sıfatını taşıyan <strong>temiz-iz.com</strong>, temizlik yönetim sistemi hizmetleri kapsamında kişisel verilerinizi işlemektedir.
          </p>

          <h2 style={S.h2}>2. İşlenen Kişisel Veriler</h2>
          <p style={S.p}>Hizmetlerimiz kapsamında aşağıdaki kişisel veriler işlenebilmektedir:</p>
          <ul style={S.ul}>
            <li style={S.li}><strong>Kimlik Bilgileri:</strong> Ad, soyad</li>
            <li style={S.li}><strong>İletişim Bilgileri:</strong> Telefon numarası, e-posta adresi</li>
            <li style={S.li}><strong>Kullanım Verileri:</strong> Anket yanıtları, memnuniyet puanları, geri bildirim içerikleri</li>
            <li style={S.li}><strong>Teknik Veriler:</strong> IP adresi, tarayıcı bilgisi, işlem zamanı</li>
          </ul>

          <h2 style={S.h2}>3. Kişisel Veri İşlemenin Amaçları</h2>
          <p style={S.p}>Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:</p>
          <ul style={S.ul}>
            <li style={S.li}>Temizlik hizmeti kalitesinin ölçülmesi ve raporlanması</li>
            <li style={S.li}>Müşteri memnuniyetinin artırılması</li>
            <li style={S.li}>İlgili kurum yöneticilerine bildirim gönderilmesi</li>
            <li style={S.li}>Hizmet kalitesinin sürekli iyileştirilmesi</li>
            <li style={S.li}>Yasal yükümlülüklerin yerine getirilmesi</li>
            <li style={S.li}>Bilgi güvenliği süreçlerinin yürütülmesi</li>
          </ul>

          <h2 style={S.h2}>4. Hukuki Dayanak</h2>
          <p style={S.p}>Kişisel verileriniz, KVKK'nın 5. maddesi kapsamında aşağıdaki hukuki dayanaklar çerçevesinde işlenmektedir:</p>
          <ul style={S.ul}>
            <li style={S.li}>Açık rızanızın alınması (madde 5/1)</li>
            <li style={S.li}>Sözleşmenin kurulması veya ifası (madde 5/2-c)</li>
            <li style={S.li}>Veri sorumlusunun meşru menfaati (madde 5/2-f)</li>
            <li style={S.li}>Yasal yükümlülüklerin yerine getirilmesi (madde 5/2-ç)</li>
          </ul>

          <h2 style={S.h2}>5. Kişisel Verilerin Aktarılması</h2>
          <p style={S.p}>
            Kişisel verileriniz; bağlı olduğunuz kurum yöneticilerine, yetkili kamu kurum ve kuruluşlarına, hizmet alınan iş ortaklarına ve teknik altyapı sağlayıcılarına aktarılabilmektedir. Yurt dışına kişisel veri aktarımı gerçekleştirilmemektedir.
          </p>

          <h2 style={S.h2}>6. Kişisel Verilerin Saklanma Süresi</h2>
          <p style={S.p}>
            Kişisel verileriniz; işleme amacının gerektirdiği süre boyunca ve yasal saklama yükümlülükleri çerçevesinde saklanmaktadır. Saklama süresinin sona ermesi veya işleme amacının ortadan kalkması halinde kişisel veriler silinmekte, yok edilmekte veya anonim hale getirilmektedir.
          </p>

          <h2 style={S.h2}>7. İlgili Kişi Hakları</h2>
          <p style={S.p}>KVKK'nın 11. maddesi kapsamında aşağıdaki haklara sahipsiniz:</p>
          <ul style={S.ul}>
            <li style={S.li}>Kişisel verilerinizin işlenip işlenmediğini öğrenme</li>
            <li style={S.li}>İşlenen kişisel verileriniz hakkında bilgi talep etme</li>
            <li style={S.li}>Kişisel verilerinizin işlenme amacını ve amaca uygun kullanılıp kullanılmadığını öğrenme</li>
            <li style={S.li}>Yurt içinde veya yurt dışında aktarıldığı üçüncü kişileri öğrenme</li>
            <li style={S.li}>Eksik veya yanlış işlenen verilerin düzeltilmesini isteme</li>
            <li style={S.li}>Kişisel verilerinizin silinmesini veya yok edilmesini isteme</li>
            <li style={S.li}>Haklarınızın üçüncü kişilere bildirilmesini isteme</li>
            <li style={S.li}>Otomatik sistemler aracılığıyla aleyhinize bir sonucun oluşmasına itiraz etme</li>
            <li style={S.li}>Kanuna aykırı veri işleme nedeniyle zararın giderilmesini talep etme</li>
          </ul>

          <h2 style={S.h2}>8. Güvenlik Tedbirleri</h2>
          <p style={S.p}>
            Kişisel verileriniz, KVKK'nın 12. maddesi uyarınca gerekli teknik ve idari tedbirler alınarak korunmaktadır. Bu kapsamda SSL/TLS şifrelemesi, güvenli sunucu altyapısı ve erişim kontrolü mekanizmaları uygulanmaktadır.
          </p>

          <h2 style={S.h2}>9. İletişim</h2>
          <p style={S.p}>
            Haklarınızı kullanmak veya aydınlatma metnine ilişkin sorularınız için aşağıdaki kanallar aracılığıyla bizimle iletişime geçebilirsiniz:
          </p>
          <p style={S.p}><strong>E-posta:</strong> info@temiz-iz.com</p>

          <div style={{ marginTop: 36, padding: '20px 24px', background: '#f0fdf4', borderRadius: 12, border: '1px solid #bbf7d0' }}>
            <p style={{ ...S.p, margin: 0, color: '#166534', fontSize: 14 }}>
              Bu aydınlatma metni, KVKK kapsamındaki yasal yükümlülüklerimiz doğrultusunda hazırlanmıştır ve gerektiğinde güncellenebilir.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
